import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 2rem auto;
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  th,
  td {
    padding: 14px 20px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    border-right: 1px solid #e0e0e0;
  }

  th:last-child,
  td:last-child {
    border-right: none;
  }

  th {
    background-color: #f9f9f9;
    font-weight: 600;
    color: #333;
    text-align: left;
  }

  tbody tr:hover {
    background-color: #fafafa;
  }

  /* Coluna Descrição com largura mínima */
  td:nth-child(2),
  th:nth-child(2) {
    min-width: 18.75rem;
    max-width: 19.5688rem;
  }

  /* Valor de Venda alinhado à direita */
  td:nth-child(3),
  th:nth-child(3) {
    text-align: right;
  }

  /* Ações alinhado ao centro */
  td:nth-child(4),
  th:nth-child(4) {
    text-align: center;
  }
`;

export const ActionButton = styled.button`
  background-color: #cf2a27;
  color: white;
  padding: 8px 16px;
  font-size: 0.875rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    opacity: 85%;
  }
`;
